import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";
import "../../components/styles/settingsPage.scss";

/**
 * SettingsPage — Account settings screen
 * Figma: Settings (Desktop) (24654:5505) — 1920×1050
 *
 * Sections:
 *   1. Navbar
 *   2. "Settings" title
 *   3. Tab bar: Settings | Subscription | Parental
 *   4. Settings card with sections: GENERAL, SECURITY
 *   5. Each row: title (bold) + description + chevron right
 */

const TABS = ["Settings", "Subscription", "Parental"];

const SETTINGS_SECTIONS = [
  {
    label: "GENERAL",
    items: [
      {
        title: "Account",
        desc: "Manage your account profile, from profile display and username",
        route: "/settings/account",
      },
      {
        title: "Subtitle appearance",
        desc: "Subtitle display settings such as text color, text size, and text background",
        route: "/settings/subtitle",
      },
      {
        title: "Notification setting",
        desc: "Notifications will be provided from email to provide the latest information from your account or your favorite films",
        route: "/settings/notifications",
      },
    ],
  },
  {
    label: "SECURITY",
    items: [
      {
        title: "Profile PIN",
        desc: "Subtitle display settings such as text color, text size, and text background",
        route: "/settings/profile-pin",
      },
      {
        title: "Parental",
        desc: "Add your child's account to manage and monitor your child's viewing",
        route: "/settings/parental",
      },
      {
        title: "Linked account",
        desc: "Connect your account to Google and Facebook to provide additional protection to your account",
        route: "/settings/social-account",
      },
      {
        title: "Manage Device",
        desc: "Manage devices linked to your account, giving you flexibility in managing other devices",
        route: "/settings/manage-device",
      },
    ],
  },
];

const ChevronRight = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M7.5 5L12.5 10L7.5 15" stroke="#737373" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const TAB_ROUTES = {
  "Settings": "/settings",
  "Subscription": "/settings/subscription",
  "Parental": "/settings/parental",
};

const SettingsPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Settings");

  return (
    <div className="settings-page">
      <Navbar activeTab="" />

      <div className="settings-page__body">
        <h1 className="settings-page__title">Settings</h1>

        {/* Tab bar */}
        <div className="settings-page__tabs">
          {TABS.map((tab) => (
            <button
              key={tab}
              className={`settings-page__tab ${
                activeTab === tab ? "settings-page__tab--active" : ""
              }`}
              onClick={() => {
                setActiveTab(tab);
                navigate(TAB_ROUTES[tab]);
              }}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Settings card */}
        <div className="settings-page__card">
          {SETTINGS_SECTIONS.map((section) => (
            <div key={section.label} className="settings-page__section">
              <span className="settings-page__section-label">{section.label}</span>
              {section.items.map((item) => (
                <button key={item.title} className="settings-page__item" onClick={() => navigate(item.route)}>
                  <div className="settings-page__item-content">
                    <h4 className="settings-page__item-title">{item.title}</h4>
                    <p className="settings-page__item-desc">{item.desc}</p>
                  </div>
                  <ChevronRight />
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
